import axios from 'axios';

import { Resolve } from './';
import config from './config';

interface IEventSettings {
  id: number;
  live_interactions: boolean;
}

const url = process.env.VUE_APP_SERVER_PATH;

interface IPlan {
  name: string;
  app_annual_event_limit: number;
  app_annual_attendee_limit: number;
  app_annual_event_manager_limit: number;
  app_annual_exhibitor_limit: number;
  one_time_price_eur: number;
  beamian_accounts_service: true,
  
  // default data
  check_in_app_service: boolean,
  custom_plan: boolean,
  check_in_max_capacity: number,
  check_in_max_events: number,
  check_in_max_event_managers: number,
  annual_price_eur: number,
  monthly_price_eur: number,
  one_time_price_usd: number,
  annual_price_usd: number,
  monthly_price_usd: number,
}

export const getPlans = () => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .get(`${url}/v2/payment-plans?check_in_app_service=false`, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});

export const getPlanById = (plan_id: number) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .get(`${url}/v2/payment-plans/${plan_id}`, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});

export const addPlan = (plan_data: IPlan) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .post(`${url}/v2/payment-plans`, plan_data, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});